<template>
  <div
    v-if="
      GET_ACCOUNT_DATA.id == 1 ||
        has_perm('create_staff') ||
        has_perm('update_staff') ||
        (parseInt(this.userdata.id) == GET_ACCOUNT_DATA.id)
    "
  >
    <form>
      <div class="">
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          color="#1E90FF"
        ></loading>
        <!-- <div class="box-header">
          <h3 class="box-title">{{ $t("user.profile") }}</h3>
        </div> -->
        <div class="box-body">
          <Avatar
            @completed="handleCompleted"
            ref="foo"
            :urlAvatar="userdata.url_avatar"
            style="cursor: pointer"
          />
          <div class="row">
            <div class="col-md-4">
              <div class="form-group required">
                <label for="fullname" class="control-label">{{
                  $t("user.fullname")
                }}</label>
                <input
                  v-model="userdata.fullname"
                  type="text"
                  class="form-control"
                  id="fullname"
                  required
                  :placeholder="$t('user.fullname')"
                  @input="validateFieldIsEmpty('fullname')"
                />
                <span
                  v-if="this.field_required.fullname != ''"
                  class="help is-danger"
                >
                  <font color="red">{{ $t(field_required.fullname) }}</font>
                </span>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group required">
                <label for="email" class="control-label">{{
                  $t("user.email")
                }}</label>
                <input
                  :disabled="userdata.id > 0"
                  v-model="userdata.email"
                  type="email"
                  class="form-control"
                  id="email"
                  required
                  placeholder="example@example.com"
                  @input="validateEmailAll('email')"
                />
                <!-- // [loitt] - check is active -->
                <span
                  :class="{
                    email_activated: email_activated,
                    show_email: show_email
                  }"
                  class="email_default"
                  >{{ status_active }}</span
                >

                <span
                  v-if="this.field_required.email != ''"
                  class="help is-danger"
                >
                  <font color="red">{{ $t(field_required.email) }}</font>
                </span>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="phone">{{ $t("user.phone") }}</label>
                <input
                  v-model="userdata.phone"
                  type="text"
                  class="form-control"
                  id="phone"
                  :placeholder="$t('user.phone')"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="form-group required">
                <label for="gender" class="control-label">{{
                  $t("user.gender")
                }}</label>
                <select v-model="userdata.gender" class="form-control">
                  <option
                    v-for="gender in gender_list"
                    v-bind:value="gender.id"
                    :key="gender.id"
                    >{{ $t(gender.text) }}</option
                  >
                </select>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="dob">{{ $t("user.dob") }}</label>
                <date-picker
                  class="form-control"
                  v-model="userdata.dob"
                  :config="options"
                  id="dob"
                ></date-picker>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="fullname">{{ $t("user.country") }}</label>
                <b-form-select
                  :options="country_list"
                  v-model="userdata.country_code"
                  class="form-control"
                />
              </div>
            </div>
            <div
              class="col-md-4"
              v-show="parseInt(this.$route.params.id) == 0 ? false : true"
            >
              <div class="form-group required" v-if="showPasswordText == true">
                <label for="password" class="control-label">{{
                  $t("user.password")
                }}</label>
                <div class="form-inline">
                  <input
                    style="width:100%;"
                    type="password"
                    v-model="userdata.password"
                    @input="validatePassword(userdata.password)"
                    class="form-control"
                    id="password"
                    placeholder="Password"
                    required
                    disabled
                  />
                  <span
                    :class="{
                      password_length_count: valid_password_length,
                      show_password_length: password_typed
                    }"
                    class="password_length"
                    >{{ password_length }}</span
                  >
                </div>
                <span
                  v-if="this.field_required.password != ''"
                  class="help is-danger"
                >
                  <font color="red">{{ $t(field_required.password) }}</font>
                </span>

                <div v-show="password_typed" class="lnu_container">
                  <p :class="{ got_lowercase: contain_lowercase }">
                    {{ $t("user.lowercase") }}
                  </p>
                  <p :class="{ got_number: contain_number }">
                    {{ $t("user.digit") }}
                  </p>
                  <p :class="{ got_uppercase: contain_uppercase }">
                    {{ $t("user.uppercase") }}
                  </p>
                </div>
              </div>
              <div class="form-group" v-else>
                <label for="password">{{ $t("user.password") }}</label>
                <div>
                  <b-button
                    v-if="isCurrentUser"
                    class="form-control"
                    variant="primary"
                    @click="showModal"
                    >{{ $t("user.password_modal[0].title") }}</b-button
                  >

                  <b-button
                    v-else
                    class="form-control"
                    variant="primary"
                    @click="showConfirmPassUser"
                    >{{ $t("user.password_modal[0].title_reset") }}</b-button
                  >
                </div>
              </div>
            </div>
          </div>

          <div
            class="row"
            v-if="
              (parseInt(this.userdata.id) == 0 
                && has_perm('create_staff')) ||
                GET_ACCOUNT_DATA.id == 1||
                has_perm('update_staff')
            "
          >
            <div class="col-md-4">
              <div class="form-group required">
                <label for="groups" class="control-label">{{
                  $t("user.group")
                }}</label>
                <select
                  v-model="userdata.groups"
                  class="form-control"
                  id="groups"
                >
                  <option value="1">{{ $t("user.group_mode[0]") }}</option>
                  <option value="2">{{ $t("user.group_mode[1]") }}</option>
                  <option value="5">{{ $t("user.group_mode[4]") }}</option>
                </select>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group required">
                <label for="dob" class="control-label">{{
                  $t("user.privilege")
                }}</label>
                <select
                  v-model="userdata.privilege"
                  class="form-control"
                  id="privilege"
                >
                  <option
                    v-for="option in GET_MEMBERROLECODES_DATA"
                    v-bind:value="option.id"
                    :key="option.id"
                    >{{ option.name }}</option
                  >
                </select>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label for="expire_date">{{ $t("user.expire_date") }}</label>
                <date-picker
                  class="form-control"
                  v-model="userdata.expire_date"
                  :config="optionsExpireDate"
                  id="expire_date"
                ></date-picker>
              </div>
            </div>
          </div>
        </div>
        <!-- /.box-body -->
        <div class="box-footer">
          <button
            type="button"
            class="btn btn-labeled btn-danger"
            @click="CancelUserList"
            style="margin-right: 5px; background-color: #f29911;border-color: #f29911;"
          >
            <span class="btn-label"> <i class="fa fa-mail-reply"></i> </span>
            {{ $t("common.back") }}
          </button>
          <!-- <button
            v-if="
              (parseInt(this.userdata.id) == 0 && has_perm('create_staff')) ||
                GET_ACCOUNT_DATA.id == 1
            "
            type="button"
            class="btn btn-labeled btn-success pull-right"
            @click="SaveUserList"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-ok"></i>
            </span>
            {{ $t("common.save") }}
          </button>
          <button
            v-else-if="
              (parseInt(this.userdata.id) != 0 && has_perm('update_staff')) ||
                GET_ACCOUNT_DATA.id == 1
            "
            type="button"
            class="btn btn-labeled btn-success pull-right"
            @click="SaveUserList"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-ok"></i>
            </span>
            {{ $t("common.save") }}
          </button> -->
          <button
            v-if="
              has_perm('create_staff') ||
              has_perm('update_staff') ||
              GET_ACCOUNT_DATA.id == 1 ||
              parseInt(this.userdata.id) === GET_ACCOUNT_DATA.id
            "
            type="button"
            class="btn btn-labeled btn-success pull-right"
            @click="SaveUserList"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-ok"></i>
            </span>
            {{ $t("common.save") }}
          </button>
          <!-- Only show with admin -->
          <button
            v-show="
              parseInt(this.$route.params.id) == 0
                ? false
                : has_perm('update_staff')
                ? true
                : false
            "
            type="button"
            class="btn btn-labeled btn-success pull-right"
            @click="clickOpenModalChangeEmail"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-ok"></i>
            </span>
            {{ $t("common.change_email") }}
          </button>

          <button
            v-show="
              parseInt(this.$route.params.id) == 0 || email_activated
                ? false
                : true
            "
            type="button"
            class="btn btn-labeled btn-success pull-right"
            @click="doResentActivattionAccount"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-ok"></i>
            </span>
            {{ $t("user.resent_activation") }}
          </button>
          <button
            v-show="
              this.GET_ACCOUNT_DATA.id != 1 ||
              email_activated ||
              parseInt(this.$route.params.id) == 0
                ? false
                : true
            "
            type="button"
            class="btn btn-labeled btn-success pull-right"
            @click="doActivateAccount"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-ok"></i>
            </span>
            {{ $t("user.activate_account") }}
          </button>
          <button
            v-if="
              parseInt(this.$route.params.id) !== 0 && 
              (has_perm('update_staff') ||
              GET_ACCOUNT_DATA.id == 1)
            "
            type="button"
            class="btn btn-labeled btn-warning pull-right"
            style="margin-right: 5px;"
            @click="onClickLockOrUnlockUser"
          >
            <span class="btn-label">
              <i v-if="userdata.is_blocked" class="fa fa-unlock" aria-hidden="true"></i>
              <i v-else class="fa fa-lock" aria-hidden="true"></i>
            </span>
            {{ $t(userdata.is_blocked ? "user.unlockUser" : "user.lockUser") }}
          </button>
        </div>
      </div>
    </form>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <router-view></router-view>
    <!-- Modal Component -->
    <div class="modal fade" id="modal-newpassword">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h1 class="modal-title">
              {{ $t("user.password_modal[0].title") }}
            </h1>
            <p style="margin-top: 30px">
              {{ $t("user.password_modal[0].guide") }}
            </p>
          </div>
          <div class="modal-body">
            <b-form>
              <b-form-group :label="$t('user.password_modal[0].oldpass')">
                <div class="form-group">
                  <div class="input-group">
                    <input
                      :type="OldPasswordFieldType"
                      v-model="oldPassword"
                      :placeholder="$t('user.password_modal[0].enteroldpass')"
                      class="form-control"
                    />
                    <span class="input-group-btn">
                      <button
                        class="btn btn-default"
                        type="button"
                        @click="switchVisibility(1)"
                      >
                        <i :class="iconFieldTypeOldPass" />
                      </button>
                    </span>
                  </div>
                </div>
              </b-form-group>

              <b-form-group :label="$t('user.password_modal[0].newpass')">
                <div class="form-group">
                  <div class="input-group">
                    <input
                      :type="NewPasswordFieldType"
                      @input="validatePassword(newPassword)"
                      v-model="newPassword"
                      :placeholder="$t('user.password_modal[0].enternewpass')"
                      class="form-control"
                      style="z-index:0"
                    />
                    <span class="input-group-btn">
                      <button
                        class="btn btn-default"
                        type="button"
                        @click="switchVisibility(2)"
                      >
                        <i :class="iconFieldTypeNewPass" />
                      </button>
                    </span>

                    <span
                      :class="{
                        password_length_count: valid_password_length,
                        show_password_length: password_typed
                      }"
                      class="password_length_modal"
                      style="z-index:0"
                      >{{ password_length }}</span
                    >
                  </div>
                  <div v-show="password_typed" class="lnu_container">
                    <p :class="{ got_lowercase: contain_lowercase }">
                      {{ $t("user.password_modal[0].lowercase") }}
                    </p>
                    <p :class="{ got_number: contain_number }">
                      {{ $t("user.password_modal[0].digit") }}
                    </p>
                    <p :class="{ got_uppercase: contain_uppercase }">
                      {{ $t("user.password_modal[0].uppercase") }}
                    </p>
                  </div>
                </div>
              </b-form-group>

              <b-form-group
                :label="$t('user.password_modal[0].confirmnewpass')"
              >
                <div class="form-group">
                  <div class="input-group">
                    <input
                      :type="ConfirmNewPasswordFieldType"
                      v-model="confirmNewPassword"
                      :placeholder="$t('user.password_modal[0].enternewpass')"
                      class="form-control"
                    />
                    <span class="input-group-btn">
                      <button
                        class="btn btn-default"
                        type="button"
                        @click="switchVisibility(3)"
                      >
                        <i :class="iconFieldTypeconfirmNewPass" />
                      </button>
                    </span>
                  </div>
                </div>
              </b-form-group>

              <b-button
                ref="formsubmitbutton"
                type="submit"
                variant="primary"
                style="display: none;"
                >{{ $t("user.password_modal[0].btn[0]") }}</b-button
              >
            </b-form>
          </div>
          <div class="modal-footer">
            <!-- <button
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >{{$t('user.password_modal[0].btn[2]')}}</button>-->
            <button
              type="button"
              class="btn btn-primary pull-left"
              @click="onUpdatePassword"
            >
              {{ $t("user.password_modal[0].btn[1]") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->

    <!-- Inform modal -->
    <div class="modal modal-default" id="inform_modal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">{{ $t("user.inform_modal[0].title") }}</h4>
          </div>
          <div class="modal-body">
            <h5 class="modal-title">{{ $t(modal_title) }}</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default pull-right"
              data-dismiss="modal"
            >
              {{ $t("user.inform_modal[0].modal_btn[0].close") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->

    <!-- //////////////////////////////////////////modal-change-email/////////////////////////////////////////////////////////// -->
    <!-- modal-change-email -->
    <div class="modal modal-default" id="modal-change-email">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h1 class="modal-title">
              {{ $t("user.change_email_modal[0].title") }}
            </h1>
            <!-- <p style="margin-top: 30px">{{$t('user.password_modal[0].guide')}}</p> -->
          </div>
          <div class="modal-body">
            <b-form>
              <b-form-group :label="$t('user.change_email_modal[0].old_email')">
                <div class="form-group">
                  <div class="input-group">
                    <input
                      :type="OldEmailFieldType"
                      v-model="oldEmail"
                      :placeholder="
                        $t('user.change_email_modal[0].enter_old_email')
                      "
                      class="form-control"
                      :disabled="true"
                    />
                    <span class="input-group-btn">
                      <button class="btn btn-default" type="button">
                        <i :class="iconFieldTypeOldEmail" />
                      </button>
                    </span>
                  </div>
                </div>
              </b-form-group>

              <b-form-group :label="$t('user.change_email_modal[0].new_email')">
                <div class="form-group">
                  <div class="input-group">
                    <input
                      :type="NewEmailFieldType"
                      @input="validateEmail(newEmail)"
                      v-model="newEmail"
                      :placeholder="
                        $t('user.change_email_modal[0].enter_new_email')
                      "
                      class="form-control"
                      style="z-index:0"
                    />
                    <span class="input-group-btn">
                      <button class="btn btn-default" type="button">
                        <i :class="iconFieldTypeNewEmail" />
                      </button>
                    </span>

                    <span v-if="this.newEmail != ''" class="help is-danger">
                      <font color="red">{{ $t(field_required.email) }}</font>
                    </span>
                  </div>
                </div>
              </b-form-group>

              <b-button
                ref="formsubmitbuttonsendmail"
                type="submit"
                variant="primary"
                style="display: none;"
                >{{ $t("user.change_email_modal[0].btn[0]") }}</b-button
              >
            </b-form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary pull-left"
              @click="showConfirmUser"
            >
              {{ $t("user.change_email_modal[0].btn[1]") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <!-- ////////////////////////////////////////////modal-change-email///////////////////////////////////////////////////////// -->

    <!-- start modal-confirm-change-email-user  -->
    <div class="modal modal-default" id="modal-confirm-change-email-user">
      <div class="modal-dialog">
        <div class="modal-content" style="top: 100px">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">{{ $t("confirm_email.title") }}</h4>
          </div>
          <div class="modal-body">
            <p>
              {{ $t("confirm_email.content_with_param") }}
              <span style="font-weight: bold;">{{ oldEmail }}</span>
              {{ $t("confirm_email.content_with_param_to") }}
              <span style="font-weight: bold;">{{ newEmail }}</span>
            </p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >
              {{ $t("confirm_email.btnClose") }}
            </button>

            <button
              type="button"
              class="btn btn-primary pull-right"
              @click="onUpdateEmail"
            >
              {{ $t("confirm_email.btnConfirm") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- end modal-confirm-change-email-user  -->

    <!-- start modal-confirm-reset-password-user  -->
    <div class="modal modal-default" id="modal-confirm-reset-password-user">
      <div class="modal-dialog">
        <div class="modal-content" style="top: 100px">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">{{ $t("confirm_pass.title") }}</h4>
          </div>
          <div class="modal-body">
            <p>{{ $t("confirm_pass.content") }}</p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >
              {{ $t("confirm_email.btnClose") }}
            </button>

            <button
              type="button"
              class="btn btn-primary pull-right"
              @click="passwodReset"
            >
              {{ $t("confirm_email.btnConfirm") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- end modal-confirm-reset-password-user  -->
    <!--  -->
    <lte-modal
      v-show="isModalVisible"
      @onConfirm="onConfirm"
      @close="closeModal"
      v-for="obj in objModal"
      :key="obj.id"
      :item="obj"
    ></lte-modal>
  </div>
</template>

<script>
import LTECoreAlert from "@/components/LTESnackBar.vue";
import datePicker from "vue-bootstrap-datetimepicker";

import moment from "moment";
import { mapGetters, mapActions } from "vuex";

import Avatar from "@/components/Avatar/Avatar.vue";
import constantsData from "@/lib/constantsData";
import Loading from "vue-loading-overlay";
import utils from '@/lib/utils';
import Enum from "../../../enum/enum";
import LTEModal from "@/components/LTEModal.vue";

export default {
  name: "UserAdd",
  data() {
    return {
      actionType: "",
      timeCurrent: "2019-01-16T06:00:00Z",
      userdata: {
        id: 0,
        password: constantsData.password_default.password,
        last_login: this.timeCurrent,
        is_superuser: false,
        username: "",
        fullname: null,
        email: null,
        is_staff: false,
        is_active: true,
        date_joined: this.timeCurrent,
        groups: 1,
        privilege: 1,
        age: 0,
        dob: "01-01-1990",
        phone: "",
        gender: null,
        country_code: null,
        url_avatar: "",
        expire_date: "",
        is_blocked: false
      },
      basepath: "",
      options: {
        format: "DD-MM-YYYY",
        useCurrent: false,
        maxDate: moment().subtract(2, "days")
      },
      optionsExpireDate: {
        format: "DD-MM-YYYY",
        useCurrent: false
      },
      country_list: [],
      showPasswordText: true,
      oldPassword: "",
      newPassword: "",
      confirmNewPassword: "",
      password_length: 0,
      password_typed: false,
      contain_lowercase: false,
      contain_uppercase: false,
      contain_number: false,
      valid_password_length: false,
      valid_password: false,
      modal_title: "",
      gender_list: constantsData.genderTypes,
      email_activated: false,
      show_email: false,
      status_active: "X",
      email_not_activate: false,

      field_required: {
        fullname: "",
        email: "",
        password: ""
      },

      objectNameData: "this.userdata.",
      objectNameRequire: "this.field_required.",
      isLoading: false,

      OldPasswordFieldType: "password",
      NewPasswordFieldType: "password",
      ConfirmNewPasswordFieldType: "password",

      iconFieldTypeOldPass: "glyphicon glyphicon-eye-open",
      iconFieldTypeNewPass: "glyphicon glyphicon-eye-open",
      iconFieldTypeconfirmNewPass: "glyphicon glyphicon-eye-open",
      isCurrentUser: false,

      // #615
      OldEmailFieldType: "email",
      NewEmailFieldType: "email",
      oldEmail: "",
      newEmail: "",
      iconFieldTypeOldEmail: "glyphicon glyphicon-envelope",
      iconFieldTypeNewEmail: "glyphicon glyphicon-envelope",
      valid_email: false,
      memberRoleList: [],
      isModalVisible: false,
      objModal: [
        {
          title: "common.delete_modal.title",
          body: "common.delete_modal.content",
          buttonNo: "common.delete_modal.btnNo",
          buttonYes: "common.delete_modal.btnYes",
          styleType: "default"
        }
      ]
    };
  },

  watch: {
    // watch user detail
    USER_DETAIL_DATA: function() {
      this.userdata.password = this.USER_DETAIL_DATA.password;
      this.userdata.username = this.USER_DETAIL_DATA.username;
      this.userdata.fullname = this.USER_DETAIL_DATA.last_name + " " + this.USER_DETAIL_DATA.first_name;
      this.userdata.email = this.USER_DETAIL_DATA.email;

      if (this.GET_ACCOUNT_DATA.email == this.USER_DETAIL_DATA.email) {
        this.isCurrentUser = true;
      }

      if (this.USER_DETAIL_DATA.profile === undefined) {
        this.userdata.phone = "";
        this.userdata.dob = null;
        this.userdata.gender = null;
        this.userdata.country_code = "";
        this.userdata.url_avatar = "";
        this.email_activated = false;
      } else {
        this.userdata.phone = utils.formatPhoneWithSpace(this.USER_DETAIL_DATA.profile.phone, "");
        this.userdata.dob = utils.formatSqlDate(this.USER_DETAIL_DATA.profile.dob, null, "DD-MM-YYYY", this.userdata.dob);
        this.userdata.gender = this.USER_DETAIL_DATA.profile.gender;
        this.userdata.country_code = this.USER_DETAIL_DATA.profile.country_code;
        this.userdata.url_avatar = this.USER_DETAIL_DATA.profile.url_avatar;
        this.email_activated = this.USER_DETAIL_DATA.profile.is_active;
      }

      // BEGIN - [loitt] - check is active
      if (this.email_activated === true) {
        this.status_active = "";
        this.email_activated = true;
      } else {
        this.status_active = "X";
        this.email_activated = false;
      }
      // END   - [loitt] - check is active

      this.userdata.password = this.USER_DETAIL_DATA.password;
      let groups = 1; // default is 1

      if (
        this.userdata.groups != undefined &&
        this.USER_DETAIL_DATA.groups.length > 0
      ) {
        groups = this.USER_DETAIL_DATA.groups[0].id;
      }

      this.userdata.groups = groups;
      this.userdata.privilege =
        this.USER_DETAIL_DATA.privilege.length > 0
          ? this.USER_DETAIL_DATA.privilege[0].id
          : null;
      this.userdata.expire_date = utils.formatSqlDate(this.USER_DETAIL_DATA.expire_date, null, "DD-MM-YYYY");
      this.userdata.is_blocked = this.USER_DETAIL_DATA.profile.is_blocked
    }
  },

  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "USER_DETAIL_DATA",
      "GET_MEMBERROLECODES_DATA",
      "GET_ACCOUNT_DATA"
    ])
  },

  methods: {
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ADD_USER",
      "GET_USER_DETAIL",
      "UPDATE_USER",
      "UPDATE_USER_EMAIL",
      "ON_SHOW_TOAST",
      "SET_USER_DATA",
      "GET_COUNTRY_LIST",
      "GET_MEMBERROLECODES",
      "ACCOUNT_PASSWORD_RESET",
      "FORCE_ACTIVE_EMAIL",
      "RESEND_ACTIVE_EMAIL",
      "POST_LOCK_OR_UNLOCK_USER"
    ]),
    doActivateAccount() {
      let data = {
        id: this.userdata.id
      };
      this.FORCE_ACTIVE_EMAIL(data)
        .then(
          function() {
            let success_title = this.$t("user.inform_modal[0].email_actived");
            this.showSuccess(success_title);
            this.email_activated = true;
            this.status_active = "";
          }.bind(this)
        )
        .catch(
          function(error) {
            let failed_title = "Unknow";
            if (error.response.data.message.includes("email_exist_in_system"))
              failed_title = "user.inform_modal[0].email_exist_in_system";

            this.showError(failed_title);
          }.bind(this)
        );
    },
    doResentActivattionAccount() {
      let data = {
        id: this.userdata.id,
        domain: Enum.domain
      };
      this.RESEND_ACTIVE_EMAIL(data)
        .then(
          function() {
            let success_title = this.$t(
              "user.inform_modal[0].re_email_actived"
            );
            this.showSuccess(success_title);
            // this.email_activated = true;
            this.status_active = "";
          }.bind(this)
        )
        .catch(
          function(error) {
            let failed_title = "Unknow";
            if (error.response.data.message.includes("email_exist_in_system"))
              failed_title = "user.inform_modal[0].email_exist_in_system";

            this.showError(failed_title);
          }.bind(this)
        );
    },

    // this.$t("customer.error_messages.email_exist")
    showError: function(msg) {
      this.ON_SHOW_TOAST({
        message: this.$t(msg),
        styleType: "danger"
      });
    },
    showSuccess: function(msg) {
      this.ON_SHOW_TOAST({
        message: msg, // this.$t(msg)
        styleType: "success"
      });
    },
    clickOpenModalChangeEmail: function() {
      $("#modal-change-email").modal("show");
      this.newEmail = "";
      this.oldEmail = this.userdata.email;
    },
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    // add show/hide password
    switchVisibility: function(typePass) {
      if (typePass == 3) {
        this.ConfirmNewPasswordFieldType =
          this.ConfirmNewPasswordFieldType === "password" ? "text" : "password";
        this.iconFieldTypeconfirmNewPass =
          this.ConfirmNewPasswordFieldType === "password"
            ? "glyphicon glyphicon-eye-open"
            : "glyphicon glyphicon-eye-close";
      }
      if (typePass == 2) {
        this.NewPasswordFieldType =
          this.NewPasswordFieldType === "password" ? "text" : "password";
        this.iconFieldTypeNewPass =
          this.NewPasswordFieldType === "password"
            ? "glyphicon glyphicon-eye-open"
            : "glyphicon glyphicon-eye-close";
      }
      if (typePass == 1) {
        this.OldPasswordFieldType =
          this.OldPasswordFieldType === "password" ? "text" : "password";
        this.iconFieldTypeOldPass =
          this.OldPasswordFieldType === "password"
            ? "glyphicon glyphicon-eye-open"
            : "glyphicon glyphicon-eye-close";
      }
    },

    // [loitt] - add validate Email empty and incorrect format
    validateEmailAll: function(
      field,
      objectName = "this.userdata.",
      objectNameRequire = "this.field_required."
    ) {
      // use for get value : this.userdata.last_name
      let exec = objectName + field;

      // this.field_required.last_name
      let error_msg = objectNameRequire + field;

      // Init data befor check
      eval(error_msg + " = ''");

      // ==> get value current
      let result = eval(exec);

      if (result == null || result == "") {
        eval(error_msg + " = 'common.error_msg[0].required'");
      } else {
        let isEmailValid = this.validateEmail(result);
        if (!isEmailValid) {
          eval(error_msg + " = 'user.inform_modal[0].email_error'");
        }
      }

      return result;
    },

    // [loitt] - add validate Field Is Empty
    validateFieldIsEmpty: function(
      field,
      objectName = "this.userdata.",
      objectNameRequire = "this.field_required."
    ) {
      // use for get value : this.userdata.last_name
      let exec = objectName + field;

      // this.field_required.last_name
      let error_msg = objectNameRequire + field;

      // Init data befor check
      eval(error_msg + " = ''");

      // ==> get value current
      let result = eval(exec);

      if (result == null || result == "") {
        eval(error_msg + " = 'common.error_msg[0].required'");
      }

      return result;
    },
    handleCompleted(url_avatar) {
      this.userdata.url_avatar = url_avatar;
    },
    onOpenServices: function() {
      this.$router.push({
        name: "ServiceHistory"
      });
    },
    onAssignService: function() {
      this.$router.push({
        name: "AssignService"
      });
    },
    CancelUserList: function() {
      this.$router.push({
        name: "UserList"
      });
    },
    showConfirmPassUser: function() {
      $("#modal-confirm-reset-password-user").modal("show");
    },
    passwodReset: function() {
      $("#modal-confirm-reset-password-user").modal("hide");
      let payload = {
        email_or_username: this.userdata.email,
        domain: Enum.domain
      };
      this.ACCOUNT_PASSWORD_RESET(payload)
        .then(
          function() {
            this.ON_SHOW_TOAST({
              message: this.$t("customer.info_send_email", {
                "0": this.userdata.email
              }),
              styleType: "success"
            });
            // this.$router.push({ name: "PasswordResetDone" });
          }.bind(this)
        )
        .catch(
          function(error) {
            this.ON_SHOW_TOAST({
              message: error.response.data.message,
              styleType: "danger"
            });
          }.bind(this)
        );
    },
    showModal: function() {
      $("#modal-newpassword").modal("show");
      this.newPassword = "";
      this.oldPassword = "";
      this.confirmNewPassword = "";
      this.password_length = 0;
      this.password_typed = false;
      this.contain_lowercase = false;
      this.contain_uppercase = false;
      this.contain_number = false;
      this.valid_password_length = false;
      this.valid_password = false;
    },
    onUpdatePassword: function() {
      if (
        this.newPassword === "" ||
        this.oldPassword === "" ||
        this.confirmNewPassword === ""
      ) {
        let required_title = "user.inform_modal[0].empty_error";
        this.showInformmodal(required_title);
      } else if (this.newPassword !== this.confirmNewPassword) {
        let confirm_title = "user.inform_modal[0].confirm_error";
        this.showInformmodal(confirm_title);
      } else if (this.valid_password == false) {
        let weakpass_title = "user.inform_modal[0].passwordInvalidate";
        this.showInformmodal(weakpass_title);
      } else {
        $("#modal-newpassword").modal("hide");
        let data = {
          id: this.userdata.id,
          password: this.newPassword,
          obsoletepassword: this.oldPassword
        };
        this.UPDATE_USER(data)
          .then(
            function() {
              let success_title = "user.inform_modal[0].updated_success";
              this.showInformmodal(success_title);
            }.bind(this)
          )
          .catch(
            function(error) {
              let failed_title = error.response.data.message;
              this.showInformmodal(failed_title);
            }.bind(this)
          );
      }
    },
    showConfirmUser: function() {
      if (this.newEmail === "" || this.oldEmail === "") {
        let required_title = "user.inform_modal[0].empty_error";
        this.showError(required_title);
      } else if (this.validateEmail(this.newEmail) == false) {
        let email_error = "user.inform_modal[0].email_error";
        this.showError(email_error);
      } else $("#modal-confirm-change-email-user").modal("show");
    },
    // #615
    onUpdateEmail: function() {
      // if (
      //   this.newEmail === "" ||
      //   this.oldEmail === ""
      // ) {
      //   let required_title = "user.inform_modal[0].empty_error";
      //   this.showError(required_title)
      // } else if (this.validateEmail(this.newEmail) == false) {
      //   let email_error = "user.inform_modal[0].email_error";
      //   this.showError(email_error)
      // } else {
      $("#modal-confirm-change-email-user").modal("hide");
      $("#modal-change-email").modal("hide");
      let data = {
        id: this.userdata.id,
        old_email: this.oldEmail,
        new_email: this.newEmail,
        domain: Enum.domain
      };
      this.UPDATE_USER_EMAIL(data)
        .then(
          function() {
            let success_title = this.$t(
              "user.inform_modal[0].email_updated_success",
              { "0": this.oldEmail, "1": this.newEmail }
            );
            this.userdata.email = this.newEmail;
            this.showSuccess(success_title);
          }.bind(this)
        )
        .catch(
          function(error) {
            let failed_title = "Unknow";
            if (error.response.data.message.includes("email_exist_in_system"))
              failed_title = "user.inform_modal[0].email_exist_in_system";

            this.showError(failed_title);
          }.bind(this)
        );
      // }
    },
    validateData: function() {
      let validatedResult = "OK";
      let isEmailValid = this.validateEmail(this.userdata.email);
      for (let key in this.userdata) {
        if (
          key == "country_code" ||
          key == "url_avatar" ||
          key == "phone" ||
          key == "username" ||
          key == "expire_date"||
          key == "gender"
        ) {
          // not validating 'country' field
        } else if (this.userdata[key] === null || this.userdata[key] === "") {
          validatedResult =
            this.$t("common.error") + " " + key + " : " + this.userdata[key];
          break;
        } else if (!isEmailValid) {
          validatedResult = this.$t("user.inform_modal[0].email_error");
          break;
        } else if (this.userdata.phone != null && this.userdata.phone != "") {
          let isPhoneValid = utils.validatePhone(
            this.userdata.phone.replace(/ /g, "")
          );
          if (!isPhoneValid) {
            validatedResult = this.$t(
              "user.inform_modal[0].phone_number_error"
            );
          }
        } else {
          //
        }
      }
      return validatedResult;
    },
    isNumeric(num) {
      return !isNaN(num);
    },
    checkForm: function() {
      let result_error = "OK";
      for (var key in this.field_required) {
        if (key === "email") {
          this.validateEmailAll(key);
        } else {
          if (!(key === "password" && this.$route.params.id != 0)) {
            this.validateFieldIsEmpty(key);
          }
        }

        let key_error = this.objectNameRequire + key;
        let t_result = eval(key_error);
        if (t_result != "") {
          result_error = t_result;
        }
      }
      return result_error;
    },
    SaveUserList: function(event) {
      this.waitingLoading(true);
      // [loitt] - changed validate data #266
      let result = this.checkForm(); // validateData
      if (result == "OK") {
        result = this.validateData();
      }

      if (result == "OK") {
        let groups = 1; // default is 1
        if (this.userdata.groups != undefined) {
          groups = this.userdata.groups;
        }
        let data = {
          domain: Enum.domain,
          last_login: this.timeCurrent, // need set time
          is_superuser: false,
          username: this.userdata.email,
          first_name: utils.getFirstLastName(this.userdata.fullname).firstName,
          last_name: utils.getFirstLastName(this.userdata.fullname).lastName,
          email: this.userdata.email,
          is_staff: false,
          is_active: true,
          date_joined: this.timeCurrent, // need set time
          groups: [groups], // this is array
          expire_date: utils.formatSqlDate(this.userdata.expire_date, "DD-MM-YYYY", "YYYY-MM-DD"),
          // infor profile
          profile: [
            {
              // age:  this.userdata.age,
              dob: utils.formatSqlDate(this.userdata.dob, "DD-MM-YYYY", "YYYY-MM-DD"),
              phone: !utils.isEmptyString(this.userdata.phone) ? this.userdata.phone.replace(/ /g, "") : null,
              gender: this.userdata.gender,
              country_code: this.userdata.country_code,
              url_avatar: this.userdata.url_avatar
            }
          ],
          // privilege
          privilege: [this.userdata.privilege],
          id: this.userdata.id
        };

        if (parseInt(this.userdata.id) == 0) {
          data["password"] = constantsData.password_default.password;
          this.ADD_USER(data)
            .then(
              function() {
                this.SET_USER_DATA();
                this.waitingLoading(false);
                this.ON_SHOW_TOAST({
                  message: this.$t("customer.info_send_email", {
                    "0": this.userdata.email
                  }),
                  styleType: "success"
                });
                this.$router.push({ name: "UserList" });
              }.bind(this)
            )
            .catch(
              function(error) {
                if (error.response.data.message.includes("email")) {
                  this.ON_SHOW_TOAST({
                    message: this.$t("customer.error_messages.email_exist"),
                    styleType: "danger"
                  });
                } else if (error.response.data.message.includes("project")) {
                  this.ON_SHOW_TOAST({
                    message: this.$t(
                      "customer.error_messages.email_exist_project"
                    ),
                    styleType: "danger"
                  });
                } else {
                  this.ON_SHOW_TOAST({
                    message: error.response.data.message,
                    styleType: "danger"
                  });
                }

                this.waitingLoading(false);
              }.bind(this)
            );
        } else {
          this.UPDATE_USER(data)
            .then(
              function() {
                this.SET_USER_DATA();
                this.waitingLoading(false);
                this.$router.push({ name: "UserList" });
              }.bind(this)
            )
            .catch(
              function(error) {
                this.ON_SHOW_TOAST({
                  message: error.response.data.message,
                  styleType: "danger"
                });
                this.waitingLoading(false);
              }.bind(this)
            );
        }
      } else if (result != "OK") {
        this.waitingLoading(false);
        this.ON_SHOW_TOAST({
          message: result,
          styleType: "danger"
        });
      } else {
        this.waitingLoading(false);
        this.ON_SHOW_TOAST({
          message: "This password is not valid",
          styleType: "danger"
        });
      }
    },
    showInformmodal: function(title) {
      this.modal_title = title;
      $("#inform_modal").modal("show");
    },
    validatePassword: function(password) {
      this.field_required.password = "";
      this.password_length = password.length;
      if (this.password_length <= 0) {
        this.field_required.password = "common.error_msg[0].required";
        return;
      }

      if (this.password_length > 7) {
        this.valid_password_length = true;
      } else {
        this.valid_password_length = false;
      }

      if (this.password_length > 0) {
        this.password_typed = true;
      } else {
        this.password_typed = false;
      }

      this.contain_lowercase = /[a-z]/.test(password);
      this.contain_uppercase = /[A-Z]/.test(password);
      this.contain_number = /\d/.test(password);

      if (
        this.contain_lowercase == true &&
        this.contain_uppercase == true &&
        this.contain_number == true &&
        this.valid_password_length == true
      ) {
        this.valid_password = true;
      } else {
        this.valid_password = false;
      }
    },
    validateEmail: function(email) {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (!pattern.test(email)) {
        email = "";
        return false;
      } else {
        return true;
      }
    },
    waitingLoading: function(bol) {
      this.isLoading = bol;
    },
    closeModal: function() {
      this.isModalVisible = false
    },
    onConfirm: function() {
      this.waitingLoading(true);
      let data = {
        id: this.userdata.id,
        // isBlocked: this.userdata.is_blocked
      }
      this.POST_LOCK_OR_UNLOCK_USER(data)
        .then(
          function(res) {
            this.userdata.is_blocked = res.data
            this.closeModal()
            this.waitingLoading(false);
          }.bind(this)
        )
        .catch(
          function(error) {
            this.ON_SHOW_TOAST({
              message: error.response.data.message,
              styleType: "danger"
            });
            this.waitingLoading(false);
          }.bind(this)
        );
    },
    onClickLockOrUnlockUser: function() {
      this.isModalVisible = true
      if (this.userdata.is_blocked) {
        this.objModal[0].body = 'user.notiUnlockUser'
      } else {
        this.objModal[0].body = 'user.notiLockUser'
      }
    }
  },
  async mounted() {
    let id = this.$route.params.id;
    this.GET_COUNTRY_LIST().then(
      function(res) {
        let countries = [
          {
            value: null,
            text: "---"
          }
        ];
        let data = res.data;
        data.forEach(c => {
          let country = {
            value: c.id,
            text: c.country_name
          };
          countries.push(country);
        });
        this.country_list = countries;
      }.bind(this)
    );

    if (parseInt(id) !== 0) {
      this.userdata.id = id;
      this.pagetitle = "Edit Campaign";
      await this.GET_USER_DETAIL({ id: id });

      this.showPasswordText = false;
      // [loitt] - initialize check is active
      this.show_email = true;
    } else {
      this.userdata.url_avatar = ""
      this.showPasswordText = false;
      // [loitt] - initialize check is active
      this.email_activated = false;
      this.show_email = false;
    }
    let filter = {
      params: {
        isCustomer: false
      }
    };
    this.GET_MEMBERROLECODES(filter);
  },
  components: {
    "lte-core-alert": LTECoreAlert,
    "date-picker": datePicker,
    Avatar,
    loading: Loading,
    "lte-modal": LTEModal,
  }
};
</script>

<style lang="" scoped>
@media (min-width: 768px) {
  .modal-dialog {
    width: 800px;
  }
}
.lnu_container {
  display: block;
  margin: 10px auto;
  margin-bottom: 0;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
}
.lnu_container p {
  width: 30%;
  height: auto;
  font-size: 12px;
  line-height: 1.2;
  text-align: center;
  border-radius: 2px;
  color: rgba(71, 87, 98, 0.8);
  background: linear-gradient(to right, #06a65a 50%, #eee 50%);
  background-size: 200% 100%;
  background-position: right;
  -webkit-transition: background 0.3s;
  transition: background 0.3s;
}
.got_lowercase,
.got_uppercase,
.got_number {
  background-position: left !important;
  color: rgba(255, 255, 255, 0.9) !important;
}
.iconFieldType {
  padding: 2px 8px;
  position: absolute;
  top: 32px;
  right: 19px;
  display: inline-block !important;
}
.show_password_length {
  display: inline-block !important ;
}
.password_length {
  padding: 2px 8px;
  position: absolute;
  top: 42px;
  right: 22px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  background: #dd4b39;
  color: white;
  border-color: #d73925;
  border-radius: 4px;
  font-size: 13px;
  display: none;
  -webkit-transition: all 0.1s;
  transition: all 0.1s;
}
.password_length_modal {
  padding: 2px 8px;
  position: absolute;
  top: 50.3%;
  right: 50px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  background: #dd4b39;
  color: white;
  border-color: #d73925;
  border-radius: 4px;
  font-size: 13px;
  display: none;
  -webkit-transition: all 0.1s;
  transition: all 0.1s;
}
.password_length_count {
  background: #06a65a;
  color: rgba(255, 255, 255, 0.9);
}

.email_default {
  padding: 2px 8px;
  position: absolute;
  top: 42px;
  right: 21px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  background: #dd4b39;
  color: white;
  border-color: #d73925;
  border-radius: 4px;
  font-size: 13px;
  display: none;
  -webkit-transition: all 0.1s;
  transition: all 0.1s;
}
.show_email {
  display: block !important;
}
.email_activated {
  background: #06a65a;
  color: rgba(255, 255, 255, 0.9);
  font-family: "Glyphicons Halflings";
}
.email_activated::after {
  content: "\E013";
}

.form-group.required .control-label:after {
  color: #d00;
  position: absolute;
  margin-left: 8px;
  margin-top: -3px;
  font-family: "FontAwesome";
  font-weight: normal;
  font-size: 9px;
  content: "\f069";
  top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/User/UserAdd.vue